export default __webpack_public_path__ + "static/aios-b1ef5ca1cf3901e5047640dd8dfce3a1.png";